import { IInsetStyles, ItemAlignment, RadiusStyle } from './types';

import { EdgeInsets } from 'react-native-safe-area-context';
import { FlexAlignType } from 'react-native';

export const getFlexForAlignment = (
  alignment: ItemAlignment
): 'flex-start' | 'flex-end' | 'center' => {
  let flex: FlexAlignType = 'flex-start'; // default

  switch (alignment) {
    case ItemAlignment.End:
      flex = 'flex-end';
      break;
    case ItemAlignment.Center:
      flex = 'center';
      break;
  }

  return flex;
};

export const getRadiusForStyle = (
  style: RadiusStyle,
  width: number | string,
  height: number
): number => {
  let radius = 0;

  switch (style) {
    case RadiusStyle.Small:
      radius = 4;
      break;
    case RadiusStyle.Medium:
      radius = 8;
      break;
    case RadiusStyle.Large:
      radius = 16;
      break;
    case RadiusStyle.ExtraLarge:
      radius = 32;
      break;
    case RadiusStyle.Circle: {
      if (typeof width === 'number') {
        radius = Math.min(width, height) / 2;
      }

      break;
    }
  }

  return radius;
};

export const getStyleForInsets = (insets: EdgeInsets): IInsetStyles => {
  const horizontalPadding = {
    paddingLeft: insets.left,
    paddingRight: insets.right,
  };

  return {
    top: { paddingTop: insets.top, ...horizontalPadding },
    mid: horizontalPadding,
    bottom: { paddingBottom: insets.bottom, ...horizontalPadding },
  };
};
